export const nanToNull = (value, originalValue) => {
  if (isNaN(originalValue) || originalValue === "") {
    return null;
  }
  return value;
};